import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  return <section aria-label="Llamada final a la acción" className="bg-brand-dark text-white py-24 px-4 relative border-t border-brand-border" data-id="element-85">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-86">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-87">
          <span className="text-xl" aria-hidden="true" data-id="element-88">
            🌟
          </span>{' '}
          PROFEPACK
        </div>

        <p className="text-xl md:text-2xl text-white/80 mb-4 italic" data-id="element-89">
          El próximo domingo podés seguir buscando material en Google.
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" data-id="element-90">
          O podés tener todo resuelto desde hoy.
        </p>

        <div className="mb-12" data-id="element-91">
          <CountdownTimer data-id="element-92" />
        </div>

        <div className="mb-16 max-w-xl mx-auto" data-id="element-93">
          <div className="bg-brand-card p-8 rounded-2xl border-2 border-brand-accent flex flex-col items-center justify-between transform md:scale-105 z-10 shadow-2xl" data-id="element-94">
            <div className="font-bold text-white mb-2 text-xl md:text-2xl text-center" data-id="element-95">
              📘 MEGAPACK SOCIALES PRIMARIA COMPLETA
            </div>
            <div className="text-white/70 text-sm md:text-base mb-6 text-center" data-id="element-96">
              6 tomos + 6 bonos + Sistema de Gestión
            </div>
            <div className="text-5xl font-heading font-black text-brand-accent mb-8" data-id="element-97">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48113651515648:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-5 rounded-2xl text-lg font-black transition-colors" data-id="element-98">
              → QUIERO MI PROFEPACK SOCIALES
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/80 font-medium mb-16 text-sm" data-id="element-99">
          <span data-id="element-100">🔒 Pago 100% seguro</span>
          <span data-id="element-101">⚡ Acceso en 5 minutos</span>
          <span data-id="element-102">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-103">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}